<template>
  <div class="mall-h5">
    <!-- 顶部导航 -->
    <div class="mh5-topbar">
      <van-icon name="arrow-left" @click="$router.back()" />
      <span>购物车</span>
      <div class="mh5-topbar__right" @click="onManage">{{ manageMode ? '完成' : '管理' }}</div>
    </div>

    <!-- 购物车列表 -->
    <div class="mh5-cart-list">
      <div v-if="cart.length === 0" class="mh5-empty">
        <div class="mh5-empty__icon">
          <van-icon name="shopping-cart-o" />
        </div>
        <div class="mh5-empty__text">购物车是空的</div>
        <div class="mh5-empty__hint">去挑选心仪的商品吧</div>
        <div class="mh5-empty__btn" @click="goHome">去逛逛</div>
      </div>

      <div v-for="item in cart" :key="item.productId" class="mh5-cart-item">
        <div class="mh5-cart-item__check" :class="{ checked: item.checked }" @click="toggleCheck(item)">
          <van-icon v-if="item.checked" name="success" />
        </div>
        <div class="mh5-cart-item__img" @click="goDetail(item.productId)">
          <img v-if="item.mainImg" :src="item.mainImg" />
          <div v-else class="mh5-noimg"><van-icon name="photo-o" /></div>
        </div>
        <div class="mh5-cart-item__body">
          <div class="mh5-cart-item__name" @click="goDetail(item.productId)">{{ item.productName }}</div>
          <div class="mh5-cart-item__spec" v-if="item.spec">{{ item.spec }}</div>
          <div class="mh5-cart-item__bottom">
            <div class="mh5-price">
              <span class="mh5-price__sym">¥</span>{{ item.price }}
            </div>
            <div class="mh5-stepper">
              <div class="mh5-stepper__btn" :class="{ disabled: item.quantity <= 1 }" @click="changeQty(item, -1)">-</div>
              <div class="mh5-stepper__num">{{ item.quantity }}</div>
              <div class="mh5-stepper__btn" @click="changeQty(item, 1)">+</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部结算栏 -->
    <div class="mh5-cart-footer" v-if="cart.length">
      <div class="mh5-cart-footer__check" @click="toggleAll">
        <div class="mh5-cart-item__check" :class="{ checked: allChecked }">
          <van-icon v-if="allChecked" name="success" />
        </div>
        <span>全选</span>
      </div>
      <div class="mh5-cart-footer__info" v-if="!manageMode">
        <div class="mh5-cart-footer__total">
          合计：<span class="mh5-price"><span class="mh5-price__sym">¥</span>{{ total }}</span>
        </div>
        <div class="mh5-cart-footer__btn" :class="{ disabled: checkedCount === 0 }" @click="goCheckout">
          结算({{ checkedCount }})
        </div>
      </div>
      <div class="mh5-cart-footer__del" v-else :class="{ disabled: checkedCount === 0 }" @click="onBatchDelete">
        删除({{ checkedCount }})
      </div>
    </div>

    <!-- 底部安全区 -->
    <div class="mh5-safe-bottom" />

    <!-- 底部 Tab 栏 -->
    <div class="mh5-tabbar">
      <div class="mh5-tabbar__item" @click="goHome">
        <van-icon name="home-o" />
        <span>首页</span>
      </div>
      <div :class="['mh5-tabbar__item', { active: true }]">
        <van-icon name="shopping-cart-o" />
        <span>购物车</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getCart, updateQty, removeItem as removeItemFn } from './cartStore'
import { restoreMallCtx, withCtx } from './mallCtx'

export default {
  name: 'MallH5Cart',
  data() {
    return {
      cart: [],
      manageMode: false
    }
  },
  computed: {
    allChecked() {
      return this.cart.length > 0 && this.cart.every(i => i.checked)
    },
    checkedCount() {
      return this.cart.filter(i => i.checked).reduce((s, i) => s + i.quantity, 0)
    },
    total() {
      return this.cart.filter(i => i.checked)
        .reduce((s, i) => s + Number(i.price) * i.quantity, 0).toFixed(2)
    }
  },
  created() {
    restoreMallCtx(this.$route)
    this.cart = getCart().map(i => ({ ...i, checked: true }))
  },
  methods: {
    toggleCheck(item) {
      item.checked = !item.checked
    },
    toggleAll() {
      const target = !this.allChecked
      this.cart.forEach(i => { i.checked = target })
    },
    changeQty(item, delta) {
      const v = item.quantity + delta
      if (v < 1) return
      item.quantity = v
      updateQty(item.productId, v)
    },
    removeItem(item) {
      removeItemFn(item.productId)
      this.cart = this.cart.filter(i => i.productId !== item.productId)
    },
    onManage() {
      this.manageMode = !this.manageMode
    },
    onBatchDelete() {
      const checked = this.cart.filter(i => i.checked)
      if (checked.length === 0) return
      this.$dialog.confirm({
        title: '提示',
        message: `确定删除选中的 ${checked.length} 件商品？`,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        checked.forEach(i => removeItemFn(i.productId))
        this.cart = this.cart.filter(i => !i.checked)
        this.manageMode = false
      }).catch(() => {})
    },
    goCheckout() {
      const checked = this.cart.filter(i => i.checked)
      if (checked.length === 0) return
      sessionStorage.setItem('mall_buy_now', JSON.stringify(checked))
      this.$router.push({ path: '/h5/mall/checkout', query: withCtx({ mode: 'cart' }) })
    },
    goDetail(productId) {
      this.$router.push({ path: '/h5/mall/detail', query: withCtx({ id: productId }) })
    },
    goHome() {
      this.$router.push({ path: '/h5/mall/list', query: withCtx() })
    }
  }
}
</script>

<style scoped>
/* ===== 全局基调 ===== */
.mall-h5 {
  min-height: 100vh;
  background: #F8F4F0;
  padding-bottom: 120px;
  -webkit-font-smoothing: antialiased;
}

/* ===== 顶部导航 ===== */
.mh5-topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  background: #fff;
  font-size: 17px;
  font-weight: 600;
  color: #3C3C3C;
  padding: 0 14px;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
}
.mh5-topbar i {
  position: absolute;
  left: 14px;
  font-size: 20px;
  color: #666;
}
.mh5-topbar__right {
  position: absolute;
  right: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #C0392B;
  cursor: pointer;
}

/* ===== 购物车列表 ===== */
.mh5-cart-list {
  padding: 12px 14px;
}

/* 空状态 */
.mh5-empty {
  text-align: center;
  padding: 80px 0;
}
.mh5-empty__icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #F0ECE6;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mh5-empty__icon i { font-size: 36px; color: #C4BDB3; }
.mh5-empty__text { font-size: 16px; color: #999; margin-bottom: 6px; }
.mh5-empty__hint { font-size: 13px; color: #C4BDB3; margin-bottom: 20px; }
.mh5-empty__btn {
  display: inline-block;
  padding: 10px 32px;
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  border-radius: 22px;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(192,57,43,0.25);
}

/* 商品条目 */
.mh5-cart-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 14px;
  padding: 14px 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  transition: transform 0.15s;
}
.mh5-cart-item__check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #D4CFC8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  color: #fff;
  transition: all 0.2s;
  font-size: 12px;
}
.mh5-cart-item__check.checked {
  background: #C0392B;
  border-color: #C0392B;
}
.mh5-cart-item__img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
  background: #FAF8F6;
  flex-shrink: 0;
  padding: 6px;
  box-sizing: border-box;
}
.mh5-cart-item__img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.mh5-noimg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #DFD8CF;
  font-size: 24px;
}
.mh5-cart-item__body {
  flex: 1;
  margin-left: 12px;
  min-width: 0;
}
.mh5-cart-item__name {
  font-size: 14px;
  color: #3C3C3C;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 500;
}
.mh5-cart-item__spec {
  font-size: 12px;
  color: #B0A89E;
  margin-top: 4px;
}
.mh5-cart-item__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

/* 价格 */
.mh5-price {
  color: #C0392B;
  font-weight: 700;
  font-size: 17px;
  line-height: 1;
}
.mh5-price__sym { font-size: 12px; font-weight: 600; }

/* 步进器 */
.mh5-stepper {
  display: flex;
  align-items: center;
  border: 1px solid #E8E3DA;
  border-radius: 6px;
  overflow: hidden;
}
.mh5-stepper__btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666;
  background: #FAF8F6;
  cursor: pointer;
  transition: background 0.15s;
}
.mh5-stepper__btn:active { background: #F0ECE6; }
.mh5-stepper__btn.disabled { color: #D4CFC8; }
.mh5-stepper__num {
  width: 36px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  border-left: 1px solid #E8E3DA;
  border-right: 1px solid #E8E3DA;
  height: 28px;
  line-height: 28px;
  color: #3C3C3C;
}

/* ===== 底部结算栏 ===== */
.mh5-cart-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 58px;
  height: 54px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 14px;
  box-shadow: 0 -1px 0 rgba(0,0,0,0.04), 0 -4px 16px rgba(0,0,0,0.05);
  z-index: 40;
}
.mh5-cart-footer__check {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  margin-right: 14px;
  cursor: pointer;
}
.mh5-cart-footer__check .mh5-cart-item__check {
  margin-right: 8px;
}
.mh5-cart-footer__info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.mh5-cart-footer__total {
  font-size: 14px;
  color: #3C3C3C;
  margin-right: 14px;
}
.mh5-cart-footer__btn {
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  padding: 10px 22px;
  border-radius: 22px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(192,57,43,0.25);
  cursor: pointer;
  transition: opacity 0.2s;
}
.mh5-cart-footer__btn.disabled {
  background: #D4CFC8;
  box-shadow: none;
  cursor: default;
}
.mh5-cart-footer__del {
  flex: 1;
  text-align: right;
  background: linear-gradient(135deg, #E85D5D, #D94040);
  color: #fff;
  padding: 10px 22px;
  border-radius: 22px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-left: auto;
  cursor: pointer;
}
.mh5-cart-footer__del.disabled {
  background: #D4CFC8;
  cursor: default;
}

/* ===== 底部安全区 ===== */
.mh5-safe-bottom { height: 8px; }

/* ===== 底部 Tab 栏 ===== */
.mh5-tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 58px;
  background: rgba(255,255,255,0.96);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  box-shadow: 0 -1px 0 rgba(0,0,0,0.04), 0 -4px 16px rgba(0,0,0,0.05);
  z-index: 50;
  padding-bottom: env(safe-area-inset-bottom);
}
.mh5-tabbar__item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #B0A89E;
  font-size: 11px;
  position: relative;
  transition: color 0.2s;
}
.mh5-tabbar__item i { font-size: 21px; }
.mh5-tabbar__item.active { color: #C0392B; }
.mh5-tabbar__item.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 22px;
  height: 3px;
  border-radius: 0 0 3px 3px;
  background: linear-gradient(90deg, #C0392B, #D0493B);
}
.mh5-tabbar__item:active { color: #D0493B; }
</style>
